module.exports = __webpack_public_path__ + "img/marker_two_yellow1.c09237df.png";